import { render, staticRenderFns } from "./KTable.vue?vue&type=template&id=5ff13a67&"
import script from "./KTable.vue?vue&type=script&lang=js&"
export * from "./KTable.vue?vue&type=script&lang=js&"
import style0 from "./KTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports